'use client';
import { useRouter } from 'next/navigation';

import { ChevronRight } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { productImpression } from '@utils/newDataLayer/productImpression';

import {
  Content,
  StyledImage,
  BottomInfo,
  BottomInfoContainer,
  Title,
  ImageWrapper,
} from './styled';

export interface Props {
  title: string;
  currency?: string;
  index?: number;
  url?: string;
  image: {
    url: string;
    alt?: string;
  };
}

const PreferredThemesItem = ({ title, image, url }: Props) => {
  const router = useRouter();
  return (
    <Content
      onClick={() => {
        productImpression({
          item_list_location: 'Ana Sayfa Yurt İçi Temalar',
          item_list_id: title.includes('Oteller') ? title : `${title} Otelleri`,
          type: 'hotel',
        });
      }}
    >
      <ImageWrapper>
        <StyledImage src={image?.url || ''} alt={image?.alt ?? title} fill />
      </ImageWrapper>

      <BottomInfoContainer>
        <BottomInfo onClick={() => router.push(url || '')} aria-label={title}>
          <Title>{title || ''}</Title>
          <CustomIcon icon={ChevronRight} fontSize={16} paletteColor='white' />
        </BottomInfo>
      </BottomInfoContainer>
    </Content>
  );
};

export default PreferredThemesItem;
